import enLang from './locales/en_US/en-US';
import jaLang from './locales/ja_JP/ja-JP';

const appLocale = {
  ja: jaLang,
  en: enLang,
};

export default appLocale;
